import { useTranslation } from 'react-i18next';

import { KycLevel, kycLevelColor, KycReview, kycReviewColor } from '@/features/kyc/store/models/kyc.model';

import { IUser, selfEmployedLegalForms, TLegalFormKey, UserTypes } from '@/features/user/store/user.model';

import { DashboardHelpers } from '@/utils/DashboardHelpers';

export function useUserInfo(user?: IUser) {
  const { t } = useTranslation();

  if (!user) {
    return {
      initial: '',
      name: '',
      userRole: undefined,
      status: undefined,
      kycReview: undefined,
      kycLevel: undefined,
      userType: undefined,
      isPhysicalUser: false,
      isSelfEmployed: false,
      isKyb: false,
    };
  }

  const userType = t(`pages.dashboard.users.userTypes.${user.userTypeId}`);

  const kycReview = {
    label: DashboardHelpers.getStatusLabelTranslation(KycReview[user.kycReview]?.toUpperCase()),
    color: kycReviewColor[user.kycReview],
  };

  const kycLevel = {
    label: DashboardHelpers.getStatusLabelTranslation(KycLevel[user.kycLevel]?.toUpperCase()),
    color: kycLevelColor[user.kycLevel],
  };
  const { initial, name } = DashboardHelpers.getUserNameAndInitials(user);
  const isPhysicalUser = user?.userTypeId === UserTypes.naturalPerson;
  const isSelfEmployed = isPhysicalUser && selfEmployedLegalForms.includes(Number(user?.legalForm) as TLegalFormKey);
  const isKyb = user?.userTypeId === UserTypes.business || isSelfEmployed;

  return {
    initial,
    name,
    userRole: DashboardHelpers.getUserRole(user),
    status: DashboardHelpers.getUserStatus(user),
    kycReview,
    kycLevel,
    userType,
    isPhysicalUser,
    isSelfEmployed,
    isKyb,
  };
}
